(function () {
  if (window.__rrBrowsePathB) return;
  window.__rrBrowsePathB = true;

      var CARDS =   [
    {
      "key": "xmas",
      "title": "Roscoe and the Christmas Gift",
      "pdp": "/products/christmas",
      "imgParts": [
        "https://cdn.shopify.com/s/files/1/0675/6663/3259/files/",
        "Roscoe_and_the_Christmas_Gift_Front_Cover.jpg?v=1762102951"
      ],
      "formats": [
        {
          "v": "pb",
          "label": "Paperback",
          "handle": "christmas",
          "variant": "51313549934891",
          "signed": "51313549902123",
          "price": 1495,
          "compare": 0,
          "physical": 1,
          "signedPrice": 1795
        },
        {
          "v": "ebook",
          "label": "Ebook",
          "handle": "roscoe-and-the-christmas-gift-ebook",
          "variant": "51751205404971",
          "signed": "",
          "price": 795,
          "compare": 0,
          "physical": 0
        }
      ]
    },
    {
      "key": "helpers",
      "title": "Roscoe and Community Helpers Never Give Up",
      "imgParts": [
        "https://cdn.shopify.com/s/files/1/0675/6663/3259/files/",
        "9855A7A4-747F-41B1-804C-2C6F92730D18.jpg?v=1762183253"
      ],
      "formats": [
        {
          "v": "pb",
          "label": "Paperback",
          "handleParts": [
            "pre-order-new-book-roscoe-and-community-",
            "helpers-never-give-up"
          ],
          "variant": "49733989269803",
          "signed": "49733987729707",
          "price": 1495,
          "compare": 0,
          "physical": 1,
          "signedPrice": 1795
        },
        {
          "v": "bi",
          "label": "Bilingual: Spanish",
          "handleParts": [
            "bilingual-english-spanish-roscoe-and-",
            "community-helpers-never-give-up-y-",
            "ayudantes-de-la-comunidad-nunca-te-",
            "des-por-vencido"
          ],
          "variant": "50395446149419",
          "signed": "50395446608171",
          "price": 1795,
          "compare": 0,
          "physical": 1,
          "signedPrice": 2095
        },
        {
          "v": "ebook",
          "label": "Ebook",
          "handleParts": [
            "roscoe-and-community-helpers-never-",
            "give-up-ebook"
          ],
          "variant": "51562445865259",
          "signed": "",
          "price": 795,
          "compare": 0,
          "physical": 0
        }
      ],
      "pdpParts": [
        "/products/pre-order-new-book-roscoe-and-",
        "community-helpers-never-give-up"
      ]
    },
    {
      "key": "activity",
      "title": "Roscoe and Friends Activity Book Ages 3-6",
      "pdp": "/products/roscoe-and-friends-activity-book-ages-3-6",
      "imgParts": [
        "https://cdn.shopify.com/s/files/1/0675/6663/3259/files/",
        "9188817C-03F4-4706-84E3-26888040B887.jpg?v=1716559272"
      ],
      "noSigned": true,
      "formats": [
        {
          "v": "pb",
          "label": "Paperback",
          "handle": "roscoe-and-friends-activity-book-ages-3-6",
          "variant": "48990853202219",
          "signed": "",
          "price": 995,
          "compare": 0,
          "physical": 1
        }
      ]
    },
    {
      "key": "wait",
      "title": "Roscoe Learns to Wait",
      "pdp": "/products/roscoewait",
      "imgParts": [
        "https://cdn.shopify.com/s/files/1/0675/6663/3259/files/",
        "068475EB-C33E-405D-9FCF-26111553C8E0.jpg?v=1734489964"
      ],
      "formats": [
        {
          "v": "pb",
          "label": "Paperback",
          "handle": "roscoewait",
          "variant": "47360164659499",
          "signed": "47360166822187",
          "price": 1495,
          "compare": 0,
          "physical": 1,
          "signedPrice": 1795
        },
        {
          "v": "bi",
          "label": "Bilingual: Spanish",
          "handleParts": [
            "bilingual-english-spanish-roscoe-learns-to-wait-",
            "aprende-a-esperar"
          ],
          "variant": "49584004104491",
          "signed": "49584010953003",
          "price": 1695,
          "compare": 0,
          "physical": 1,
          "signedPrice": 1995
        },
        {
          "v": "ebook",
          "label": "Ebook",
          "handle": "roscoe-learns-to-wait-ebook",
          "variant": "47989336113451",
          "signed": "",
          "price": 795,
          "compare": 0,
          "physical": 0
        }
      ]
    },
    {
      "key": "bossy",
      "title": "Roscoe the Bossy Rooster",
      "pdp": "/products/roscoe-the-bossy-rooster-paperback",
      "imgParts": [
        "https://cdn.shopify.com/s/files/1/0675/6663/3259/",
        "products/Roscoe_the_Bossy_Rooster_cover_image.jpg?v=1761912939"
      ],
      "formats": [
        {
          "v": "pb",
          "label": "Paperback",
          "handle": "roscoe-the-bossy-rooster-paperback",
          "variant": "44865148420395",
          "signed": "44865191903531",
          "price": 1495,
          "compare": 0,
          "physical": 1,
          "signedPrice": 1795
        },
        {
          "v": "bi",
          "label": "Bilingual: Spanish",
          "handle": "roscoe-the-bossy-rooster-el-gallo-mandon",
          "variant": "47846331285803",
          "signed": "47846331318571",
          "price": 1695,
          "compare": 0,
          "physical": 1,
          "signedPrice": 1995
        },
        {
          "v": "hc",
          "label": "Hardcover",
          "handle": "roscoe-the-bossy-rooster-hardcover",
          "variant": "50599308099883",
          "signed": "50599308067115",
          "price": 1995,
          "compare": 0,
          "physical": 1,
          "signedPrice": 2295
        },
        {
          "v": "ebook",
          "label": "Ebook",
          "handle": "roscoe-the-bossy-rooster-ebook",
          "variant": "47989346861355",
          "signed": "",
          "price": 795,
          "compare": 0,
          "physical": 0
        }
      ]
    }
  ];

  function joinParts(obj, key, partsKey) {
    if (obj[key]) return obj[key];
    if (obj[partsKey]) return obj[partsKey].join('');
    return '';
  }

  function money(cents) {
    return '$' + ((Number(cents) || 0) / 100).toFixed(2);
  }

  function signedDeltaLabel(deltaCents) {
    var d = Math.round(Number(deltaCents) || 0);
    if (d <= 0) return 'Signed by Becky';
    if (d % 100 === 0) return 'Signed by Becky +$' + (d / 100);
    return 'Signed by Becky +$' + (d / 100).toFixed(2);
  }

  function setSignedRowLabel(row, deltaCents) {
    if (!row) return;
    var span = row.querySelector('span');
    var cb = row.querySelector('.rr-signed') || row.querySelector('input');
    if (span) span.textContent = signedDeltaLabel(deltaCents);
    if (cb) cb.setAttribute('data-addon', String(Math.max(0, Math.round(Number(deltaCents) || 0))));
  }


  function priceHtml(f) {
    if (f.compare) return '<s>' + money(f.compare) + '</s>' + money(f.price);
    return money(f.price);
  }

  function el(html) {
    var d = document.createElement('div');
    d.innerHTML = html.trim();
    return d.firstChild;
  }

  function buildCard(c) {
    var pdp = joinParts(c, 'pdp', 'pdpParts');
    var img = joinParts(c, 'img', 'imgParts');
    var formats = '';
    for (var i = 0; i < c.formats.length; i++) {
      var f = c.formats[i];
      var checked = i === 0 ? ' checked' : '';
      var sp = f.signedPrice ? (' data-signed-price="' + f.signedPrice + '"') : '';
      var sc = f.signedCompare ? (' data-signed-compare="' + f.signedCompare + '"') : '';
      var handle = joinParts(f, 'handle', 'handleParts');
      formats += '<label class="rr-format"><span class="rr-format-left">'
        + '<input type="radio" name="rr-fmt-' + c.key + '" value="' + f.v + '"' + checked
        + ' data-handle="' + handle + '"'
        + ' data-variant="' + f.variant + '"'
        + ' data-signed-variant="' + (f.signed || '') + '"'
        + ' data-price="' + f.price + '" data-compare="' + (f.compare || '') + '"'
        + ' data-physical="' + f.physical + '"' + sp + sc + '>'
        + '<span>' + f.label + '</span></span>'
        + '<span class="rr-format-price">' + priceHtml(f) + '</span></label>';
    }
    var article = el(
      '<article class="rr-card" data-rr-card data-title="' + c.title + '" data-pdp="' + pdp + '">'
      + '<a class="cover" href="' + pdp + '"><img src="' + img + '" alt="' + c.title + '"></a>'
      + '<div class="rr-card-body"><h3><a href="' + pdp + '">' + c.title + '</a></h3>'
      + '<div class="rr-formats" role="radiogroup" aria-label="Format">' + formats + '</div>'
      + '<button type="button" class="rr-cta" data-rr-atc>Add to cart</button>'
      + '<div class="rr-card-status" data-rr-status aria-live="polite"></div>'
      + '</div></article>'
    );
    if (!c.noSigned) {
      var body = article.querySelector('.rr-card-body');
      var btn = body.querySelector('[data-rr-atc]');
      var row = document.createElement('label');
      row.className = 'rr-signed-row';
      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.className = 'rr-signed';
      var firstFmt = c.formats && c.formats[0] ? c.formats[0] : null;
      var initDelta = 300;
      if (firstFmt && firstFmt.signedPrice) initDelta = firstFmt.signedPrice - (firstFmt.price || 0);
      cb.setAttribute('data-addon', String(Math.max(0, initDelta)));
      var span = document.createElement('span');
      span.textContent = signedDeltaLabel(initDelta);
      row.appendChild(cb);
      row.appendChild(span);
      var note = document.createElement('div');
      note.className = 'rr-signed-note';
      note.setAttribute('aria-live', 'polite');
      body.insertBefore(row, btn);
      body.insertBefore(note, btn);
    }
    return article;
  }

  var PATHB_DYNAMIC_HANDLES = {
    'bundles': 'Bundles',
    'merch': 'Merch',
    'parent-teacher-counselor-collection': 'Teaching Resources'
  };

  function collectionHandleFromPath() {
    var m = location.pathname.match(/\/collections\/([^\/\?]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function isAllProductsPage() {
    return /\/collections\/all\/?$/.test(location.pathname);
  }

  function isBooksPage() {
    return collectionHandleFromPath() === 'books';
  }

  function isDynamicPathBCollection() {
    return !!PATHB_DYNAMIC_HANDLES[collectionHandleFromPath()];
  }


  function pathBHandles() {
    var set = {};
    for (var i = 0; i < CARDS.length; i++) {
      var c = CARDS[i];
      for (var j = 0; j < c.formats.length; j++) {
        var h = joinParts(c.formats[j], 'handle', 'handleParts');
        if (h) set[h] = true;
      }
    }
    return set;
  }

  function moneySimple(cents) {
    return '$' + ((Number(cents) || 0) / 100).toFixed(2);
  }

  function priceToCents(price) {
    if (typeof price === 'string') return Math.round(parseFloat(price) * 100);
    return Number(price) || 0;
  }

  function splitSignedVariants(p) {
    var unsigned = null;
    var signed = null;
    var variants = p.variants || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var title = ((v.title || '') + ' ' + (v.option1 || '')).toLowerCase();
      if (title.indexOf('signed') !== -1) {
        if (!signed) signed = v;
      } else if (!unsigned && v.available !== false) {
        unsigned = v;
      }
    }
    if (!unsigned && variants.length) {
      for (var j = 0; j < variants.length; j++) {
        var t = ((variants[j].title || '') + ' ' + (variants[j].option1 || '')).toLowerCase();
        if (t.indexOf('signed') === -1) { unsigned = variants[j]; break; }
      }
    }
    if (!unsigned && variants.length) unsigned = variants[0];
    return { unsigned: unsigned, signed: signed };
  }

  function buildSimpleCard(p) {
    var img = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    var split = splitSignedVariants(p);
    var variant = split.unsigned;
    if (!variant) return null;
    var priceCents = priceToCents(variant.price);
    var signedId = split.signed ? String(split.signed.id) : '';
    var signedCents = split.signed ? priceToCents(split.signed.price) : 0;
    var safeTitle = (p.title || '').replace(/"/g, '&quot;');
    var article = el(
      '<article class="rr-card rr-card-simple" data-rr-simple data-handle="' + p.handle + '">'
      + '<a class="cover" href="/products/' + p.handle + '"><img src="' + img + '" alt="' + safeTitle + '"></a>'
      + '<div class="rr-card-body"><h3><a href="/products/' + p.handle + '">' + (p.title || '') + '</a></h3>'
      + '<div class="rr-simple-price" data-rr-simple-price>' + moneySimple(priceCents) + '</div>'
      + '<button type="button" class="rr-cta" data-rr-atc'
      + ' data-variant="' + variant.id + '"'
      + ' data-signed-variant="' + signedId + '"'
      + ' data-price="' + priceCents + '"'
      + ' data-signed-price="' + signedCents + '">Add to cart</button>'
      + '<div class="rr-card-status" data-rr-status aria-live="polite"></div>'
      + '</div></article>'
    );
    if (signedId) {
      var body = article.querySelector('.rr-card-body');
      var btn = body.querySelector('[data-rr-atc]');
      var row = document.createElement('label');
      row.className = 'rr-signed-row';
      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.className = 'rr-signed';
      cb.checked = false;
      var delta = Math.max(0, (signedCents || 0) - (priceCents || 0));
      cb.setAttribute('data-addon', String(delta));
      var span = document.createElement('span');
      span.textContent = signedDeltaLabel(delta);
      row.appendChild(cb);
      row.appendChild(span);
      body.insertBefore(row, btn);
    }
    return article;
  }

  function syncSimpleCard(card) {
    var btn = card.querySelector('[data-rr-atc]');
    var signed = card.querySelector('.rr-signed');
    var priceEl = card.querySelector('[data-rr-simple-price]');
    if (!btn || !priceEl) return;
    var base = parseInt(btn.getAttribute('data-price'), 10) || 0;
    var signedPrice = parseInt(btn.getAttribute('data-signed-price'), 10) || 0;
    if (signed && signed.checked && signedPrice) priceEl.textContent = moneySimple(signedPrice);
    else priceEl.textContent = moneySimple(base);
  }

  function bindSimpleCard(card) {
    var btn = card.querySelector('[data-rr-atc]');
    if (!btn) return;
    var signed = card.querySelector('.rr-signed');
    if (signed) {
      signed.checked = false;
      signed.addEventListener('change', function () {
        var status = card.querySelector('[data-rr-status]');
        if (status) { status.textContent = ''; status.classList.remove('is-error', 'is-ok'); }
        syncSimpleCard(card);
      });
      syncSimpleCard(card);
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var wantSigned = signed && signed.checked;
      var id = wantSigned
        ? (btn.getAttribute('data-signed-variant') || btn.getAttribute('data-variant'))
        : btn.getAttribute('data-variant');
      var status = card.querySelector('[data-rr-status]');
      btn.disabled = true;
      if (status) { status.textContent = ''; status.classList.remove('is-error', 'is-ok'); }
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      }).then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error((body && (body.description || body.message)) || 'Could not add to cart');
          return body;
        });
      }).then(function () {
        if (status) { status.textContent = 'Added to cart'; status.classList.add('is-ok'); }
        window.location.href = '/cart';
      }).catch(function (err) {
        if (status) { status.textContent = (err && err.message) || 'Could not add to cart'; status.classList.add('is-error'); }
        btn.disabled = false;
      });
    });
  }

  function fetchCollectionProducts(handle) {
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=50', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('collection ' + handle); return r.json(); })
      .then(function (d) {
        var prods = (d && d.products) || [];
        prods.sort(function (a, b) { return (b.created_at || '').localeCompare(a.created_at || ''); });
        return prods;
      });
  }

  function mountBooksGrid(into) {
    var grid = el('<div class="rr-grid"></div>');
    for (var i = 0; i < CARDS.length; i++) grid.appendChild(buildCard(CARDS[i]));
    into.appendChild(grid);
  }

  function mountSimpleGrid(into, products, skip) {
    var grid = el('<div class="rr-grid"></div>');
    var added = 0;
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      if (!p || !p.handle) continue;
      if (skip[p.handle]) continue;
      if ((p.title || '').toLowerCase().indexOf('gift card') !== -1) continue;
      var card = buildSimpleCard(p);
      if (!card) continue;
      grid.appendChild(card);
      skip[p.handle] = true;
      added++;
    }
    if (added) into.appendChild(grid);
    return added;
  }

  function mountDynamicCollection(handle, title) {
    var root = document.getElementById('rr-books-root');
    var wrap = el('<div class="rr-wrap rr-browse-wrap"><section class="rr-browse" data-cat="' + handle + '"></section></div>');
    var section = wrap.querySelector('.rr-browse');
    root.appendChild(wrap);
    return fetchCollectionProducts(handle).then(function (prods) {
      mountSimpleGrid(section, prods, {});
      section.querySelectorAll('[data-rr-simple]').forEach(bindSimpleCard);
    }).catch(function () {
      section.innerHTML = '<p style="text-align:center;color:#666;">Could not load products.</p>';
    });
  }

  function mount() {
    var root = document.getElementById('rr-books-root');
    if (!root) return;
    root.innerHTML = '';

    var handle = collectionHandleFromPath();

    // Bundles / Merch / Teaching Resources: fetch collection products → Path B cards
    if (isDynamicPathBCollection()) {
      mountDynamicCollection(handle, PATHB_DYNAMIC_HANDLES[handle]);
      return;
    }

    // Books (and any other non-all mount): curated Path B book cards
    if (!isAllProductsPage()) {
      var wrap = el('<div class="rr-wrap rr-browse-wrap"><section class="rr-browse"></section></div>');
      mountBooksGrid(wrap.querySelector('.rr-browse'));
      root.appendChild(wrap);
      document.querySelectorAll('[data-rr-card]').forEach(bindCard);
      return;
    }

    // All Products: category groups, newest → oldest within each
    var wrap = el('<div class="rr-wrap rr-browse-wrap rr-all-products"></div>');
    root.appendChild(wrap);
    var skip = pathBHandles();

    var booksSec = el('<section class="rr-browse rr-cat" data-cat="books"><h2 class="rr-cat-title">Books</h2></section>');
    wrap.appendChild(booksSec);
    mountBooksGrid(booksSec);

    var sections = [
      { handle: 'bundles', title: 'Bundles' },
      { handle: 'merch', title: 'Merch' },
      { handle: 'parent-teacher-counselor-collection', title: 'Teaching Resources' }
    ];

    var chain = Promise.resolve();
    sections.forEach(function (sec) {
      chain = chain.then(function () {
        return fetchCollectionProducts(sec.handle).then(function (prods) {
          var section = el('<section class="rr-browse rr-cat" data-cat="' + sec.handle + '"><h2 class="rr-cat-title">' + sec.title + '</h2></section>');
          var n = mountSimpleGrid(section, prods, skip);
          if (n) wrap.appendChild(section);
          section.querySelectorAll('[data-rr-simple]').forEach(bindSimpleCard);
        }).catch(function () {});
      });
    });
    chain.then(function () {
      document.querySelectorAll('[data-rr-card]').forEach(bindCard);
    });
  }

  mount();

var productCache = {};

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function isSignedVariant(v) {
    if (!v) return false;
    var blob = ((v.title || '') + ' ' + (v.option1 || '') + ' ' + (v.name || '')).toLowerCase();
    return blob.indexOf('signed') !== -1;
  }

  function findSignedId(product) {
    if (!product || !product.variants) return '';
    for (var i = 0; i < product.variants.length; i++) {
      if (isSignedVariant(product.variants[i])) return String(product.variants[i].id);
    }
    return '';
  }

  function findDefaultId(product) {
    if (!product || !product.variants || !product.variants.length) return '';
    for (var i = 0; i < product.variants.length; i++) {
      if (!isSignedVariant(product.variants[i])) return String(product.variants[i].id);
    }
    return String(product.variants[0].id);
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('product ' + handle + ' ' + r.status);
      return r.json();
    }).catch(function (err) {
      delete productCache[handle];
      throw err;
    });
    return productCache[handle];
  }

  function selectedRadio(card) {
    return card.querySelector('.rr-formats input[type="radio"]:checked');
  }

  function syncCard(card) {
    var radio = selectedRadio(card);
    var signedRow = card.querySelector('.rr-signed-row');
    var signed = card.querySelector('.rr-signed');
    var note = card.querySelector('.rr-signed-note');
    var totalEl = card.querySelector('[data-rr-total]');
    if (!radio) return;
    if (!signedRow || !signed) return; // no Signed UI on this card
    function setTotal(html) { if (totalEl) totalEl.innerHTML = html; }

    var physical = radio.getAttribute('data-physical') === '1';
    var signedId = (radio.getAttribute('data-signed-variant') || '').trim();
    var price = parseInt(radio.getAttribute('data-price'), 10) || 0;
    var compare = parseInt(radio.getAttribute('data-compare'), 10) || 0;
    var signedPrice = parseInt(radio.getAttribute('data-signed-price'), 10) || 0;
    var signedCompare = parseInt(radio.getAttribute('data-signed-compare'), 10) || 0;

    if (!physical) {
      signed.checked = false;
      signed.disabled = true;
      signedRow.hidden = true;
      signedRow.classList.remove('is-disabled');
      note.classList.remove('is-visible');
      note.textContent = '';
      setTotal(money(price));
      return;
    }

    signedRow.hidden = false;
    if (!signedId) {
      signed.checked = false;
      signed.disabled = true;
      signedRow.classList.add('is-disabled');
      note.textContent = 'Signed not available for this format yet.';
      note.classList.add('is-visible');
      setTotal(compare ? ('<s>' + money(compare) + '</s>' + money(price)) : money(price));
      return;
    }

    signed.disabled = false;
    signedRow.classList.remove('is-disabled');
    note.classList.remove('is-visible');
    note.textContent = '';

    var deltaCents = signedPrice ? (signedPrice - price) : (parseInt(signed.getAttribute('data-addon'), 10) || 0);
    setSignedRowLabel(signedRow, deltaCents);

    if (signed.checked) {
      if (signedPrice) {
        setTotal(signedCompare
          ? ('<s>' + money(signedCompare) + '</s>' + money(signedPrice))
          : money(signedPrice));
      } else {
        var addon = parseInt(signed.getAttribute('data-addon'), 10) || 300;
        var withSign = price + addon;
        var withSignCompare = compare ? (compare + addon) : 0;
        setTotal(withSignCompare
          ? ('<s>' + money(withSignCompare) + '</s>' + money(withSign))
          : money(withSign));
      }
    } else {
      setTotal(compare ? ('<s>' + money(compare) + '</s>' + money(price)) : money(price));
    }
  }

  function resolveVariantId(card) {
    var radio = selectedRadio(card);
    var signed = card.querySelector('.rr-signed');
    if (!radio) return Promise.reject(new Error('No format selected'));

    var handle = radio.getAttribute('data-handle') || '';
    var unsignedId = (radio.getAttribute('data-variant') || '').trim();
    var signedId = (radio.getAttribute('data-signed-variant') || '').trim();
    var physical = radio.getAttribute('data-physical') === '1';
    var wantSigned = physical && signed && signed.checked;

    function fromAttrs() {
      if (wantSigned) {
        if (signedId) return Promise.resolve(signedId);
        return Promise.reject(new Error('Signed variant not available for this format'));
      }
      if (unsignedId) return Promise.resolve(unsignedId);
      return fetchProduct(handle).then(function (p) {
        var id = findDefaultId(p);
        if (!id) throw new Error('No variant for ' + handle);
        return id;
      });
    }

    // Prefer wired IDs; verify Signed via product.js when checkbox on and ID missing.
    if (wantSigned && !signedId) {
      return fetchProduct(handle).then(function (p) {
        var id = findSignedId(p);
        if (!id) throw new Error('Signed variant not available for this format');
        radio.setAttribute('data-signed-variant', id);
        syncCard(card);
        return id;
      });
    }

    // Soft-verify signed availability on first physical select (non-blocking for ATC if attrs present)
    if (physical && handle && signedId === '' && !radio.getAttribute('data-signed-checked')) {
      radio.setAttribute('data-signed-checked', '1');
      fetchProduct(handle).then(function (p) {
        var id = findSignedId(p);
        if (id) radio.setAttribute('data-signed-variant', id);
        syncCard(card);
      }).catch(function () {});
    }

    return fromAttrs();
  }

  function setStatus(card, msg, kind) {
    var el = card.querySelector('[data-rr-status]');
    if (!el) return;
    el.textContent = msg || '';
    el.classList.remove('is-error', 'is-ok');
    if (kind) el.classList.add(kind);
  }

  function refreshCartUI() {
    try {
      if (typeof window.refreshCart === 'function') window.refreshCart();
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart && cart.item_count != null ? cart.item_count : null;
        if (count == null) return;
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble .cart-count, [data-cart-count]').forEach(function (n) {
          n.textContent = String(count);
        });
        document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
          if (count > 0) b.classList.remove('hidden');
          else b.classList.add('hidden');
        });
        document.querySelectorAll('[data-rr-cart-count]').forEach(function (el) {
          if (count > 0) { el.textContent = String(count); el.classList.add('is-visible'); }
          else { el.textContent = ''; el.classList.remove('is-visible'); }
        });
      }).catch(function () {});
  }

  function addToCart(card) {
    var btn = card.querySelector('[data-rr-atc]');
    setStatus(card, '', null);
    if (btn) btn.disabled = true;
    return resolveVariantId(card).then(function (id) {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      }).then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) {
            var msg = (body && (body.description || body.message)) || 'Could not add to cart';
            throw new Error(msg);
          }
          return body;
        });
      });
    }).then(function () {
      setStatus(card, 'Added to cart', 'is-ok');
      refreshCartUI();
      window.location.href = '/cart';
    }).catch(function (err) {
      setStatus(card, (err && err.message) || 'Could not add to cart', 'is-error');
    }).then(function () {
      if (btn) btn.disabled = false;
    });
  }

  function bindCard(card) {
    card.querySelectorAll('.rr-formats input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', function () {
        // Uncheck signed when switching formats so default OFF holds per selection
        var signed = card.querySelector('.rr-signed');
        if (signed) signed.checked = false;
        setStatus(card, '', null);
        syncCard(card);
        // Probe Signed availability via product.js when attr empty
        var sel = selectedRadio(card);
        if (sel && sel.getAttribute('data-physical') === '1' && !(sel.getAttribute('data-signed-variant') || '').trim()) {
          fetchProduct(sel.getAttribute('data-handle')).then(function (p) {
            var id = findSignedId(p);
            if (id) sel.setAttribute('data-signed-variant', id);
            else sel.setAttribute('data-signed-variant', '');
            syncCard(card);
          }).catch(function () { syncCard(card); });
        }
      });
    });
    var signed = card.querySelector('.rr-signed');
    if (signed) {
      signed.checked = false; // default OFF
      signed.addEventListener('change', function () {
        setStatus(card, '', null);
        syncCard(card);
      });
    }
    var btn = card.querySelector('[data-rr-atc]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(card);
      });
    }
    syncCard(card);
  }

  
  document.querySelectorAll('[data-rr-card]').forEach(bindCard);
})();
